// Takes any function `cb` and returns a promise that will resolve to the return of `cb` after `time` milliseconds have elapsed:
export const wrapTimeout = (cb: () => any, time: number): Promise<any> => new Promise((resolve) => setTimeout(() => resolve(cb()), time));
